import {Skeleton} from "@mui/material";
import {locationsApi, useGetLocationQuery} from "@/redux/rtk/admin/locations";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {sharedSelectors, updateLocationDetails} from "@/redux/slices/admin/shared";
import {useEffect} from "react";
import {LOCATION_PROPS} from "@/redux/rtk/admin/locations/types";

const LocationName = ({uid}: { uid: number }) => {
    const {data, isLoading} = useGetLocationQuery(uid);
    const dispatch= useDispatch();
    const locationDetails = useSelector(state => sharedSelectors.getLocationDetails(state), shallowEqual);

    useEffect(() => {
        if(data?.data?.locationDetails?.[0]) {
            dispatch(updateLocationDetails(data.data.locationDetails[0] as LOCATION_PROPS))
        }
    }, [data])

    useEffect(() => {
        return () => {
            dispatch(locationsApi.util.resetApiState());
        };
    }, [dispatch]);

    return <>
        {isLoading ? <Skeleton sx={{width: "5rem"}} variant="text"/> :
            !locationDetails ? null : `${locationDetails.name}`}
    </>
}

export default LocationName;